export * from './tree';

import { TreeComponent } from './tree';

export const TreeAtoms = [
    TreeComponent
]